import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getCollectedListAction } from "../../../../Services/Store/Actions/BookingsAction";
import {
  BookingItemType,
  PaginationType,
} from "../../../../Constants/Interfaces";
import RightSlidingPanel from "../../../Admin/Components/RightSlidingPanel";
import BookingInfoPanel from "./BookingInfoPanel";
import ActionMenu from "../../../../Components/ActionMenu";
import Pagination from "../../../../Components/Pagination";
import { renderBookingStatus } from "./bookingStatus";

interface CollectedBookingListType {
  search: string;
}

const CollectedBookingList: React.FC<CollectedBookingListType> = ({
  search = "",
}) => {
  const dispatch = useDispatch();

  const { collectedList } = useSelector((state: any) => state.bookings);

  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState<BookingItemType[]>([]);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [rightSidePanel, setRightSidePanel] = useState<{
    show: boolean;
    item: BookingItemType | null;
  }>({
    show: false,
    item: null,
  });

  const getBookingsList = (page: number) => {
    if (!loading) {
      setLoading(true);
      const params = {
        page,
        limit: 20,
        search,
      };

      getCollectedListAction(params, dispatch)
        .then((res) => {
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          console.log("ERR: ", err);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setBookings(collectedList);
  }, [collectedList]);

  useEffect(() => {
    getBookingsList(1);
  }, []);

  return (
    <div className="listing-tables">
      <Table responsive>
        <thead>
          <tr>
            <th>Space Name</th>
            <th>Amount</th>
            <th>Booking Date</th>
            <th className="text-center" style={{ width: 100 }}>
              Status
            </th>
            <th className="action-col">Action</th>
          </tr>
        </thead>

        <tbody>
          {!loading && bookings.length === 0 && (
            <tr>
              <td colSpan={5} align="center">
                No Bookings available
              </td>
            </tr>
          )}
          {bookings.length > 0 &&
            bookings.map((item, index) => (
              <tr key={`booking-${item.id}`}>
                <td>{item?.space?.name || ""}</td>
                <td>${item.grossAmount}</td>
                <td>{moment(item.startDate).format("MM/DD/YYYY")}</td>
                <td className="text-center">
                  {renderBookingStatus(item?.status)}
                </td>
                <td className="action-col">
                  <ActionMenu
                    items={[
                      {
                        label: "Details",
                        icon: faChevronRight,
                        onClick: () => setRightSidePanel({ show: true, item }),
                      },
                    ]}
                  />
                </td>
              </tr>
            ))}

          {loading && (
            <tr>
              <td colSpan={5} align="center">
                <FontAwesomeIcon icon={faSpinner} spin />
              </td>
            </tr>
          )}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan={5}>
              <Pagination
                pagination={pagination}
                onPageChange={(page) => getBookingsList(page)}
              />
            </td>
          </tr>
        </tfoot>
      </Table>

      {rightSidePanel.show && (
        <RightSlidingPanel
          title={`Booking Info`}
          show={rightSidePanel.show}
          onClosePanel={() => setRightSidePanel({ show: false, item: null })}
        >
          <BookingInfoPanel
            item={rightSidePanel.item}
            listType="collected"
            closePanel={() => setRightSidePanel({ show: false, item: null })}
          />
        </RightSlidingPanel>
      )}
    </div>
  );
};

export default CollectedBookingList;
